import * as yup from "yup";

export const schema = yup.object().shape({
  category_id: yup.number().notRequired(),
  section_id: yup.number().notRequired(),
  subsection_id: yup.number().notRequired(),
  highlights: yup
    .array()
    .required()
    .min(1, "É necessário selecionar pelo menos 1 artigo")
    .max(10, "É permitido selecionar no máximo 10 artigos"),
});
